// PLIK GENEROWANY przez scripts/cke-math-exams.cjs - nie edytuj ręcznie.
// Struktura arkuszy (numery zadań, punkty, kody wymagań) z zasad oceniania CKE.
import { exam, t, type ExamSheet } from './types';

export const MATH_EXAMS: ExamSheet[] = [
  exam({
    id: 'mat-2605-pr',
    level: 'PR',
    kind: 'main',
    date: '2026-05',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Matematyka/poziom_rozszerzony/MMAP-R0-100-A-2605-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Matematyka/poziom_rozszerzony/MMAP-R0-100-2605-zasady.pdf',
    tasks: [
      t('1', 2, ['XI.R2','VI.R1']),
      t('2', 3, ['XII.1']),
      t('3', 3, ['II.R5']),
      t('4', 3, ['VIII.8','VIII.11']),
      t('5', 4, ['III.R4']),
      t('6', 4, ['VI.7']),
      t('7', 4, ['VII.R6']),
      t('8', 4, ['X.R2']),
      t('9', 5, ['IX.R3','IX.R4']),
      t('10', 5, ['III.R5']),
      t('11', 6, ['VIII.R1']),
      t('12.1', 3, ['VIII.8']),
      t('12.2', 4, ['XIII.R4','XIII.R5','XIII.R6']),
    ],
  }),
  exam({
    id: 'mat-2605-pp',
    level: 'PP',
    kind: 'main',
    date: '2026-05',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Matematyka/poziom_podstawowy/MMAP-P0-100-A-2605-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Matematyka/poziom_podstawowy/MMAP-P0-100-2605-zasady.pdf',
    tasks: [
      t('1', 1, ['I.1','I.4']),
      t('2', 1, ['I.8']),
      t('3', 1, ['I.4']),
      t('4', 1, ['I.9']),
      t('5', 1, ['I.2','I.4']),
      t('6', 1, ['II.1']),
      t('7', 2, ['I.2']),
      t('8', 1, ['III.5']),
      t('9', 1, ['III.1']),
      t('10', 2, ['III.4']),
      t('11', 2, ['IV.2']),
      t('12.1', 2, ['V.3','V.4']),
      t('12.2', 2, ['V.4','I.6']),
      t('13.1', 1, ['V.5']),
      t('13.2', 1, ['V.11']),
      t('14', 4, ['V.9']),
      t('15', 3, ['VI.7']),
      t('16', 1, ['VI.5']),
      t('17', 1, ['VI.6']),
      t('18', 1, ['VII.1']),
      t('19', 1, ['VIII.5']),
      t('20', 1, ['VIII.7']),
      t('21', 2, ['VIII.11']),
      t('22', 1, ['VIII.3','VIII.10']),
      t('23', 1, ['VII.2']),
      t('24.1', 1, ['IX.3']),
      t('24.2', 1, ['VIII.10']),
      t('25', 1, ['IX.3','IX.4']),
      t('26', 1, ['IX.2','IX.1']),
      t('27', 2, ['X.2','X.5']),
      t('28', 1, ['X.5']),
      t('29', 1, ['XI.2']),
      t('30', 2, ['XII.1']),
      t('31', 1, ['XII.2']),
      t('32', 1, ['XII.2']),
      t('33.1', 1, ['V.11']),
      t('33.2', 1, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2601-pp',
    level: 'PP',
    kind: 'mock',
    date: '2026-03',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/probny_egzamin/2026_marzec/Matematyka/MMAP-P0-100-A-2601-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/probny_egzamin/2026_marzec/Matematyka/MMAP-P0-100-2601-zasady.pdf',
    tasks: [
      t('1', 1, ['I.1']),
      t('2', 1, ['I.3']),
      t('3', 1, ['I.4']),
      t('4', 1, ['I.1','I.9']),
      t('5', 2, ['I.2','II.1']),
      t('6', 1, ['II.4']),
      t('7', 1, ['III.5']),
      t('8', 2, ['III.4']),
      t('9', 1, ['IV.1']),
      t('10', 1, ['V.5']),
      t('11.1', 1, ['V.4']),
      t('11.2', 2, ['V.3','V.4']),
      t('11.3', 2, ['V.4','I.6']),
      t('12', 3, ['V.7','V.11']),
      t('13', 1, ['V.13']),
      t('14', 3, ['VI.1','VI.7']),
      t('15', 1, ['VI.4','VI.7','VI.5']),
      t('16', 1, ['VI.6']),
      t('17', 2, ['VII.2']),
      t('18', 1, ['VII.4']),
      t('19', 1, ['VIII.10']),
      t('20', 1, ['VIII.5']),
      t('21', 3, ['VIII.11']),
      t('22', 1, ['VIII.3']),
      t('23', 1, ['IX.2']),
      t('24', 4, ['IX.3','IX.4','IX.5']),
      t('25', 1, ['X.3','VIII.3']),
      t('26', 2, ['X.3','X.5']),
      t('27', 1, ['VIII.9','X.6']),
      t('28', 1, ['XI.2']),
      t('29', 1, ['XII.1']),
      t('30', 1, ['XII.2']),
      t('31', 1, ['XII.2']),
      t('32.1', 1, ['V.10']),
      t('32.2', 1, ['V.10']),
    ],
  }),
  exam({
    id: 'mat-2505-pr',
    level: 'PR',
    kind: 'main',
    date: '2025-05',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/Matematyka/poziom_rozszerzony/MMAP-R0-100-A-2505-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/zasady_oceniania/MMAP-R0-100-2505-zasady.pdf',
    tasks: [
      t('1', 2, ['V.14']),
      t('2', 3, ['II.R5']),
      t('3', 3, ['VII.R8']),
      t('4', 3, ['XII.R1']),
      t('5', 4, ['III.R4']),
      t('6', 4, ['VI.R2']),
      t('7', 4, ['VIII.11']),
      t('8', 5, ['IX.R2','IX.R3']),
      t('9', 5, ['VII.R6']),
      t('10', 5, ['X.3','X.5']),
      t('11', 6, ['III.R3','III.R5']),
      t('12.1', 2, ['X.5']),
      t('12.2', 4, ['XIII.R4','XIII.R5','XIII.R6']),
    ],
  }),
  exam({
    id: 'mat-2505-pp',
    level: 'PP',
    kind: 'main',
    date: '2025-05',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/Matematyka/poziom_podstawowy/MMAP-P0-100-A-2505-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/zasady_oceniania/MMAP-P0-100-2505-zasady.pdf',
    tasks: [
      t('1', 1, ['I.3','I.4']),
      t('2', 1, ['I.4']),
      t('3', 1, ['I.9']),
      t('4', 1, ['II.1','II.2']),
      t('5', 2, ['I.2']),
      t('6', 1, ['III.3','I.6']),
      t('7', 1, ['III.5']),
      t('8', 1, ['II.4']),
      t('9', 2, ['IV.2']),
      t('10', 2, ['III.4']),
      t('11', 4, ['V.4','I.6']),
      t('12.1', 2, ['V.9']),
      t('12.2', 1, ['V.11']),
      t('12.3', 1, ['V.12','V.4']),
      t('13', 1, ['V.5','V.6']),
      t('14.1', 1, ['VI.2']),
      t('14.2', 1, ['VI.4']),
      t('15', 3, ['VI.7']),
      t('16', 1, ['VI.6']),
      t('17', 1, ['VII.2']),
      t('18.1', 1, ['VII.1']),
      t('18.2', 1, ['VII.1']),
      t('19', 1, ['VIII.5']),
      t('20', 1, ['VIII.8']),
      t('21', 1, ['VII.3']),
      t('22', 1, ['IX.3']),
      t('23', 1, ['IX.2']),
      t('24', 1, ['IX.4']),
      t('25', 3, ['X.4','X.5']),
      t('26', 1, ['X.5']),
      t('27', 1, ['XI.2']),
      t('28', 1, ['XII.1']),
      t('29', 1, ['XII.2']),
      t('30', 2, ['XII.2']),
      t('31', 4, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2412-pr',
    level: 'PR',
    kind: 'diagnostic',
    date: '2024-12',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Matematyka/poziom_rozszerzony/MMAP-R0-100-A-2412-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Matematyka/poziom_rozszerzony/MMAP-R0-100-200-300-400-700-Q00-K00-2412-zasady.pdf',
    tasks: [
      t('1', 2, ['V.14']),
      t('2', 2, ['VIII.11']),
      t('3', 3, ['X.5']),
      t('4', 3, ['I.R']),
      t('5', 3, ['XII.R1']),
      t('6', 4, ['III.R4']),
      t('7', 4, ['IX.R1','IX.R4']),
      t('8', 4, ['VI.R1']),
      t('9', 4, ['VII.R6']),
      t('10', 5, ['VI.7']),
      t('11', 5, ['III.R3','III.R5']),
      t('12', 5, ['VII.1','VII.R5','VII.R7']),
      t('13.1', 2, ['V.3']),
      t('13.2', 4, ['XIII.R4','XIII.R5','XIII.R6']),
    ],
  }),
  exam({
    id: 'mat-2412-pp',
    level: 'PP',
    kind: 'diagnostic',
    date: '2024-12',
    era: 2024,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Matematyka/poziom_podstawowy/MMAP-P0-100-A-2412-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Matematyka/poziom_podstawowy/MMAP-P0-100-200-300-400-700-Q00-K00-MMAU-2412-zasady.pdf',
    tasks: [
      t('1', 1, ['I.7']),
      t('2', 1, ['I.4']),
      t('3', 2, ['I.2','I.4']),
      t('4', 1, ['I.9']),
      t('5', 1, ['I.8']),
      t('6', 1, ['II.4']),
      t('7', 1, ['IV.1']),
      t('8', 3, ['III.1','III.4']),
      t('9', 2, ['III.4']),
      t('10', 4, ['V.4']),
      t('11', 1, ['V.6','V.11']),
      t('12.1', 1, ['V.4']),
      t('12.2', 2, ['V.9']),
      t('12.3', 1, ['V.12']),
      t('13', 1, ['V.14']),
      t('14', 1, ['VI.1','VI.4']),
      t('15', 1, ['VI.7']),
      t('16', 1, ['VI.6']),
      t('17.1', 1, ['VII.1']),
      t('17.2', 1, ['VII.1']),
      t('18', 1, ['VII.2']),
      t('19', 4, ['VIII.8']),
      t('20', 1, ['VIII.5','VIII.6']),
      t('21', 1, ['IX.3']),
      t('22', 1, ['IX.2']),
      t('23', 1, ['IX.4']),
      t('24', 1, ['X.3','X.5']),
      t('25', 1, ['X.5']),
      t('26', 2, ['X.4','X.5']),
      t('27', 1, ['XI.2']),
      t('28', 2, ['XII.1']),
      t('29', 2, ['XII.2']),
      t('30', 4, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2405-pr',
    level: 'PR',
    kind: 'main',
    date: '2024-05',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Matematyka/poziom_rozszerzony/MMAP-R0-100-A-2405-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Matematyka/poziom_rozszerzony/MMAP-R0-100-2405-zasady.pdf',
    tasks: [
      t('1', 2, ['V.13']),
      t('2', 2, ['XIII.R1']),
      t('3', 3, ['XII.R2']),
      t('4', 3, ['XIII.R2','XIII.R3']),
      t('5', 3, ['I.9','I.R1']),
      t('6', 3, ['XI.R1']),
      t('7', 4, ['VI.6']),
      t('8', 4, ['VIII.R3']),
      t('9', 4, ['VIII.7']),
      t('10', 5, ['VII.R6']),
      t('11', 5, ['IX.3','IX.5','IX.R1']),
      t('12', 6, ['III.R3','III.R5']),
      t('13.1', 2, ['X.4']),
      t('13.2', 4, ['XIII.R3','XIII.R4','XIII.R5']),
    ],
  }),
  exam({
    id: 'mat-2405-pp',
    level: 'PP',
    kind: 'main',
    date: '2024-05',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Matematyka/poziom_podstawowy/MMAP-P0-100-A-2405-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Matematyka/poziom_podstawowy/MMAP-P0-100-2405-zasady.pdf',
    tasks: [
      t('1', 1, ['I.7']),
      t('2', 1, ['I.4']),
      t('3', 2, ['I.2']),
      t('4', 1, ['I.1']),
      t('5', 1, ['II.1']),
      t('6', 1, ['III.3']),
      t('7', 1, ['III.6']),
      t('8', 1, ['II.2','III.5']),
      t('9', 3, ['III.5']),
      t('10', 1, ['IV.2']),
      t('11', 1, ['IV.1']),
      t('12', 1, ['V.5']),
      t('13', 1, ['V.6']),
      t('14.1', 1, ['V.4']),
      t('14.2', 1, ['V.9']),
      t('14.3', 1, ['V.3']),
      t('14.4', 2, ['V.12']),
      t('15', 1, ['VI.1']),
      t('16', 1, ['VI.2','VI.6']),
      t('17', 2, ['VI.4']),
      t('18', 2, ['VII.1','VII.2']),
      t('19', 1, ['VII.2']),
      t('20', 1, ['VIII.7']),
      t('21', 1, ['VIII.11']),
      t('22', 1, ['VIII.5']),
      t('23', 1, ['IX.2']),
      t('24', 2, ['IX.3']),
      t('25.1', 1, ['X.4']),
      t('25.2', 1, ['X.2']),
      t('26', 1, ['X.5']),
      t('27', 1, ['XI.2']),
      t('28', 1, ['XII.2']),
      t('29', 1, ['XII.2']),
      t('30', 2, ['XII.1']),
      t('31', 4, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2312-pp',
    level: 'PP',
    kind: 'diagnostic',
    date: '2023-12',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/diagnostyczne_12_23/matematyka/MMAP-P0-100-A-2312-arkusz.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/diagnostyczne_12_23/matematyka/MMAP-P0-100-200-300-400-660-Q00-K00-MMAU-100-2312-zasady.pdf',
    tasks: [
      t('1', 1, ['I.1','I.4']),
      t('2', 1, ['I.1','I.9']),
      t('3', 1, ['I.8']),
      t('4', 1, ['I.7']),
      t('5', 2, ['I.2']),
      t('6', 1, ['IV.1']),
      t('7', 1, ['II.1','II.5']),
      t('8', 1, ['III.5','V.2']),
      t('9', 3, ['III.1','III.5']),
      t('10', 1, ['V.5']),
      t('11.1', 1, ['V.4']),
      t('11.2', 1, ['V.4']),
      t('11.3', 2, ['V.9']),
      t('11.4', 1, ['V.12']),
      t('12', 1, ['V.13','V.2']),
      t('13', 1, ['VI.4']),
      t('14', 1, ['VI.1','VI.5']),
      t('15', 1, ['VI.6']),
      t('16', 2, ['VII.1']),
      t('17', 1, ['VII.1','VII.2']),
      t('18', 1, ['IX.2']),
      t('19', 1, ['IX.2']),
      t('20', 1, ['IX.4']),
      t('21', 1, ['IX.3']),
      t('22', 1, ['VIII.5','VIII.7']),
      t('23', 1, ['VIII.4','VIII.11']),
      t('24', 2, ['VIII.1','VIII.8']),
      t('25', 1, ['X.1','X.2','X.4']),
      t('26', 3, ['X.2','X.3','X.4']),
      t('27', 2, ['XI.1','XI.2','VI.6']),
      t('28', 1, ['XII.1']),
      t('29.1', 1, ['XII.1']),
      t('29.2', 1, ['XII.2']),
      t('30', 4, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2305-pr',
    level: 'PR',
    kind: 'main',
    date: '2023-05',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Matematyka/poziom_rozszerzony/MMAP-R0-100-2305.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Matematyka/poziom_rozszerzony/MMAP-R0-100-2305-zasady.pdf',
    tasks: [
      t('1', 2, ['V.13']),
      t('2', 3, ['XII.R2']),
      t('3', 3, ['XIII.R2','XIII.R3']),
      t('4', 3, ['II.R3']),
      t('5', 3, ['VIII.R3']),
      t('6', 3, ['VII.R6']),
      t('7', 4, ['X.1','X.R5']),
      t('8', 4, ['VIII.R1']),
      t('9', 4, ['II.1','III.R4']),
      t('10', 4, ['VI.R2']),
      t('11', 5, ['III.R3','III.R5']),
      t('12.1', 2, ['I.R1','I.9']),
      t('12.2', 4, ['XIII.R3','XIII.R4']),
      t('13', 6, ['VII.R5','IX.R3']),
    ],
  }),
  exam({
    id: 'mat-2305-pp',
    level: 'PP',
    kind: 'main',
    date: '2023-05',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Matematyka/poziom_podstawowy/MMAP-P0-100-2305.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Matematyka/poziom_podstawowy/MMAP-P0-100-2305-zasady.pdf',
    tasks: [
      t('1', 1, ['I.7']),
      t('2', 1, ['I.4']),
      t('3', 2, ['I.2']),
      t('4', 1, ['I.1']),
      t('5', 1, ['II.1']),
      t('6', 1, ['III.3']),
      t('7', 1, ['III.5']),
      t('8', 1, ['III.6']),
      t('9', 3, ['III.5']),
      t('10', 1, ['IV.1']),
      t('11', 2, ['IV.2']),
      t('12.1', 1, ['V.4']),
      t('12.2', 1, ['V.4']),
      t('12.3', 1, ['V.4']),
      t('13', 1, ['V.5']),
      t('14', 1, ['V.11']),
      t('15', 1, ['VI.1']),
      t('16', 1, ['VI.6']),
      t('17', 2, ['VI.4']),
      t('18', 1, ['VII.1']),
      t('19', 1, ['VII.2']),
      t('20', 1, ['VIII.4']),
      t('21', 1, ['VIII.5']),
      t('22', 2, ['VIII.8']),
      t('23', 1, ['IX.1']),
      t('24', 1, ['IX.2']),
      t('25', 1, ['X.2','X.3','VII.4']),
      t('26', 4, ['X.4']),
      t('27', 1, ['XI.1']),
      t('28', 1, ['XI.1']),
      t('29', 2, ['XII.2']),
      t('30', 2, ['XII.1']),
      t('31.1', 1, ['V.3','V.2']),
      t('31.2', 2, ['XIII']),
    ],
  }),
  exam({
    id: 'mat-2209-pp',
    level: 'PP',
    kind: 'diagnostic',
    date: '2022-09',
    era: 2018,
    sheetUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/diagnostyczne/matematyka/MMAP-P0-100-2209.pdf',
    keyUrl: 'https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/diagnostyczne/matematyka/MMAP-P0-100-200-300-400-660-700-Q00-2209-zasady.pdf',
    tasks: [
      t('1', 1, ['I.1']),
      t('2', 1, ['I.9']),
      t('3', 1, ['XI.2']),
      t('4', 1, ['II.6']),
      t('5', 2, ['II.1','II.2']),
      t('6', 3, ['III.5']),
      t('7', 1, ['III.6']),
      t('8', 1, ['I.6','I.7']),
      t('9', 1, ['IV.2']),
      t('10.1', 1, ['V.4']),
      t('10.2', 1, ['V.4']),
      t('11', 1, ['IX.4']),
      t('12.1', 1, ['V.2']),
      t('12.2', 2, ['V.5','V.6']),
      t('13.1', 1, ['V.8']),
      t('13.2', 1, ['V.4']),
      t('14.1', 1, ['VI.1']),
      t('14.2', 1, ['VI.3','VI.5']),
      t('15', 1, ['IX.2']),
      t('16.1', 1, ['VI.2']),
      t('16.2', 1, ['III.3']),
      t('16.3', 1, ['VI.1','VI.3','VI.4']),
      t('17', 1, ['IX.2']),
      t('18', 1, ['VII.2']),
      t('19', 1, ['XII.1']),
      t('20', 1, ['VIII.5']),
      t('21', 2, ['VII.4','VIII.2']),
      t('22', 1, ['VIII.7']),
      t('23', 4, ['XIII']),
      t('24.1', 1, ['XII.2']),
      t('24.2', 1, ['XII.2']),
      t('24.3', 1, ['I.1']),
      t('25', 3, ['VII.4','VIII.2']),
      t('26', 2, ['I.2']),
    ],
  }),
];
